import { getLanguageCode } from '../utilities';

export default class ShipmentTrackingClient
{
    constructor()
    {
        let languageCode = getLanguageCode();

        this._uri = '/v1-api-shipment-details-' + languageCode;
        this._dataSrc = 'shipmentDetailsList';
    }

    get uri()
    {
        return this._uri;
    }

    get dataSrc()
    {
        return this._dataSrc;
    }

    /**
	 * GET
	 */

    /**
	 * @returns {Promise<Response>}
	 */
    fetchAllItems()
    {
        return fetch(this._uri + '/items');
    }

    /**
	 * @param orderId
	 * @returns {Promise<Response>}
	 */
    // fetchOrder(orderId) {
    //	return fetch(this._uri + '/' + orderId);
    // }

    /**
	 * @param orderId
	 * @param offset
	 * @param limit
	 * @returns {Promise<Response>}
	 */
    fetchItems(orderId, offset, limit)
    {
        return fetch(this._uri + '/' + orderId + '/items', {
            headers: {
                'Content-Type': 'application/json'
            },
            body: {
                'skip': offset,
                'take': limit
            }
        });
    }
}
